/**
 * @generated SignedSource<<48d4f39aabffeea74f9129f2ef770ea5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarDetails_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarDetailsAbout_item" | "PdpRespSidebarDetailsCustomization_item" | "PdpRespSidebarDetailsPricingGuidance_item">;
  readonly " $fragmentType": "PdpRespSidebarDetails_item";
};
export type PdpRespSidebarDetails_item$key = {
  readonly " $data"?: PdpRespSidebarDetails_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarDetails_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDisplay"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarDetails_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarDetailsAbout_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarDetailsCustomization_item"
    },
    {
      "condition": "afterDisplay",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespSidebarDetailsPricingGuidance_item"
        }
      ]
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "bc4970d2daaf6bf41a3d9280f92f5eb9";

export default node;
